// 1. Create Lenis instance with sane defaults
const lenis = new Lenis({
	lerp: 0.1, // Smoothness factor (0 = no smoothing, 1 = never stops). 0.1 gives a nice silky feel.
	wheelMultiplier: 0.8, // Tame the mouse wheel so it doesn't scroll a mile per tick
	touchMultiplier: 1.2, // Slightly faster than native touch scroll (1 = native). 1.2 feels responsive without being twitchy.
	smoothWheel: true, // Enable smooth scroll on mouse wheel – the whole reason we use Lenis
	smoothTouch: false, // Disable smooth scroll on touch devices. iOS/Android already have butter-smooth native scrolling; adding Lenis on top just causes double-inertia bugs.
	infinite: false, // Keep it real, no infinite loops
});

// Expose Lenis globally so you can mess with it in the console or other modules
window.lenis = lenis;

// 2. Keep ScrollTrigger synced – without this, ScrollTrigger wouldn't know where the page actually is
lenis.on("scroll", ScrollTrigger.update);

// 3. Drive Lenis with the real high-res timestamp instead of GSAP's internal clock.
//    This prevents timing drift and makes sure Lenis always gets the true frame time.
function lenisRaf() {
	lenis.raf(performance.now());
}

// 4. Register our raf function on GSAP's ticker with priority.
//    false = run every frame (not just once)
//    true  = prioritize: fire BEFORE GSAP's engine updates. This guarantees Lenis moves the scroll position first,
//            then ScrollTrigger reads the fresh position, all in the same frame.
gsap.ticker.add(lenisRaf, false, true);

// 5. Kill GSAP's built-in lag smoothing. It can fight with Lenis's own inertia and make scroll feel "sticky".
//    (Minor downside: if the browser drops frames, animations might hitch instead of being smoothed – worth it for scroll responsiveness.)
gsap.ticker.lagSmoothing(0);

// 6. Cleanup function – call this when your component/page unmounts (crucial in SPAs!).
//    Otherwise Lenis keeps listening, memory leaks, and you'll have multiple scroll monsters fighting each other.
function destroyLenis() {
	lenis.destroy(); // Remove internal listeners
	gsap.ticker.remove(lenisRaf); // Stop feeding it frames
	window.lenis = null; // Clean up global
}
